import {RoutedTabsFactory} from "../Boilerplate/RoutedTabs";
import React, {Component} from "react";
import {Route, Switch} from "react-router-dom";
import BidDashboard from "./BidDashboard";
import BidEdit from "./BidEdit";
import {BidFiles} from "./BidFiles";
import BidContacts from "./BidContacts";
import {Icon} from "antd";
import * as R from 'ramda';
import {connect} from "react-redux";
import {withLoading404} from "../Boilerplate/deferLoaderHoc";
import {getBid, setBidViewed} from "../../actions/bids";
import {PathBreadcrumbItem, withBreadcrumbCurried} from "../Boilerplate/BreadcrumbContext";
import {setViewPath} from "../../actions/view";
import {canViewContacts} from "../Boilerplate/permissions";
import BidConvert from "./BidConvert";

export class Bid extends Component {
  getTabs = () => {
    const { bid } = this.props;
    const contactsTab = {
      key: 'contacts',
      text: 'Contacts',
      icon: <Icon type='contacts'/>,
      dest: params => '/bids/' + params.bidId + '/contacts/',
      selected: { path: "/bids/:bidId/contacts" }
    };
    let tabs = [
      {
        key: 'dashboard',
        text: 'Dashboard',
        icon: <Icon type='dashboard'/>,
        dest: params => '/bids/' + params.bidId,
        selected: { path: "/bids/:bidId", exact: true }
      },
      {
        key: 'files',
        text: 'Files',
        icon: <Icon type='folder-open'/>,
        dest: params => '/bids/' + params.bidId + '/files/',
        selected: { path: "/bids/:bidId/files" }
      }
    ];
    if (canViewContacts(bid)) tabs.splice(1, 0, contactsTab);
    return tabs;
  };

  componentDidMount() {
    if (!this.props.bid.resource.viewed) this.props.setViewed && this.props.setViewed();
  }

  render() {
    const NavBar = RoutedTabsFactory(this.getTabs(), 'dashboard', { className: 'subnav', force: true });

    return (
      <div>
        <NavBar/>
        <Route exact path="/bids/:bidId" component={BidDashboard}/>
        <Route path="/bids/:bidId/edit" component={BidEdit}/>
        <Route path='/bids/:bidId/files' component={BidFiles}/>
        <Route path='/bids/:bidId/contacts' component={BidContacts}/>
        <Route path="/bids/:bidId/convert" component={BidConvert}/>
      </div>
    );
  }
}

const BidBreadcrumb = props => PathBreadcrumbItem({ path: '/bids/', resource: props.bid.resource });

export default R.compose(
  connect(
    (state, props) => {
      const bid = state.view.data[props.match.params.bidId];
      if (!bid) return { loading: true };
      if (bid.status) return { status: bid.status, resource: 'bid' };
      return { bid };
    },
    (dispatch, props) => ({
      setViewed: () => dispatch(setBidViewed(props.match.params.bidId)),
      preload: () => dispatch(getBid(props.match.params.bidId)),
      loader: () => dispatch(setViewPath(['bids', props.match.params.bidId])),
    }),
  ),
  withLoading404,
  withBreadcrumbCurried(BidBreadcrumb),
)(Bid)



// WEBPACK FOOTER //
// ./src/components/Bids/Bid.js